import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  Box,
  Typography,
  Container,
  Button,
} from '@mui/material';
import {
  NewReleases as NovidadesIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import NovidadesManagement from '../../components/admin/NovidadesManagement';

const NovidadesPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Verificar se é WhiteLabel baseado na rota ou propriedade do usuário
  const isWhiteLabel = location.pathname.includes('/whitelabel') || user?.isWhiteLabel || user?.role === 'whitelabel';

  const handleBackClick = () => {
    const basePath = isWhiteLabel ? '/admin/whitelabel' : '/admin/super-admin';
    navigate(basePath);
  };

  // Não mostrar o header quando estamos em subrotas
  const basePath = isWhiteLabel ? '/admin/whitelabel' : '/admin/super-admin';
  const isSubRoute = location.pathname !== `${basePath}/novidades` &&
    !location.pathname.endsWith(`${basePath}/novidades/`);

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {!isSubRoute && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBackClick}
            sx={{ mr: 2, textTransform: 'none' }}
          >
            Voltar
          </Button>
          <NovidadesIcon sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
            Novidades
          </Typography>
        </Box>
      )}
      <NovidadesManagement />
    </Container>
  );
};

export default NovidadesPage;

